import React, { useState, useMemo } from 'react';

import { Form } from 'react-final-form';
import InputMask from 'react-input-mask';

import { validateRegExpPattern, required } from '../../helpers/validation';
import PhoneVerificationForm from '../Auth/PhoneVerificationForm';

export default function BnplEnterCode({ className, onSubmitInternal, onResendCodeInternal }) {
  const formOptions = useMemo(() => {
    return {
      fields: new Array(6).fill('').map((_, i) => ({
        name: `code${i}`,
        validate: required("Code can't be empty"),
        required: true,
        autoFocus: i === 0,
      })),
    };
  }, []);

  return (
    <div className={className}>
      <div className={`${className}__title`}>
        <h1>Enter Code</h1>
      </div>
      <div className={`${className}__verification__code`}>
        <p className={`${className}__verification__code__title`}>Fill the code</p>
        <div className={`${className}__verification__code__content`}>
          <Form
            onSubmit={onSubmitInternal}
            mutators={{
              setValue: (args, state, utils) => {
                utils.changeValue(state, args[0], () => [args[1]]);
              },
            }}
            initialValues={{
              code0: '',
              code1: '',
              code2: '',
              code3: '',
              code4: '',
              code5: '',
              code: '',
            }}
            render={(props) => <PhoneVerificationForm {...props} formOptions={formOptions} />}
          />
          <p className={`${className}__verification__code__content__description`}>
            Code is sent. If you still didn’t get the code, please make sure you’ve filled your
            phone number correctly.
          </p>
        </div>
        <p className={`${className}__resend__code`}>
          Didn't receive the code? <span onClick={onResendCodeInternal}>Resend code</span>
        </p>
      </div>
    </div>
  );
}
